import { useHasSession, useIsLoggedInToMyRac } from "raci-react-library";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { standardPageRoutes } from "../../routing/routes.config";
import { useBffApiClient } from "../useApiClient";

export const useGetWebChatInformation = () => {
  const client = useBffApiClient();
  const location = useLocation();
  const isAuthenticated = useIsLoggedInToMyRac();
  const hasSession = useHasSession();
  const [getPointOfContactId, setPointOfContactId] = useState("");
  const [getShouldRenderWebChat, setShouldRenderWebChat] = useState(false);
  const [getCrmId, setCrmId] = useState("");
  const disallowPages = standardPageRoutes.map((route) => route.path.toLowerCase());
  const currentLocation = location.pathname.toLowerCase();
  const shouldGetWebChatInformation = isAuthenticated && hasSession && !disallowPages?.includes(currentLocation);

  useEffect(() => {
    let isCancelled = false;

    const getWebChatId = async () => {
      try {
        if (!isCancelled) {
          if (shouldGetWebChatInformation) {
            const response = await client.getWebChatContactId();
            setPointOfContactId(response.result.pointOfContactId ?? "");
            setCrmId(response.result.crmId ?? "");
            setShouldRenderWebChat(true);
          } else {
            setShouldRenderWebChat(false);
          }
        }
      } catch {
        setPointOfContactId("");
        setShouldRenderWebChat(false);
      }
    };

    getWebChatId();

    return () => {
      isCancelled = true;
    };
  }, [client, currentLocation, shouldGetWebChatInformation]);

  return {
    pointOfContactId: getPointOfContactId,
    crmId: getCrmId,
    shouldRender: getShouldRenderWebChat,
  };
};

export default useGetWebChatInformation;
